/**
 * Centralized z-index constants for consistent stacking order across the app.
 * Higher values stack on top of lower values.
 *
 * Usage:
 * - Import the constant: `import { Z_INDEX } from '@/lib/constants/z-index'`
 * - Use in className: `className={cn("fixed inset-0", Z_INDEX.OVERLAY)}`
 */

export const Z_INDEX = {
	/** Default stacking context (base level) */
	DEFAULT: "z-0",

	/** Dropdown menus, tooltips, and popovers */
	DROPDOWN: "z-[10000]",

	/** Modal overlays and dialogs */
	OVERLAY: "z-[20000]",

	/** Toasts and notifications (highest priority) */
	TOAST: "z-[30000]",
} as const;

/**
 * Type-safe z-index values
 */
export type ZIndexValue = (typeof Z_INDEX)[keyof typeof Z_INDEX];
